import React, { useEffect } from 'react';
import EngineeringBanner from './EngineeringBanner';
import Automotivemobilitecards from './Automotivemobilitecards';
import AutomobilityTabs from './AutomobilityTabs';
import Automobilityverticaltabs from './Automobilityverticaltabs';
import AerospaceIntroductioncards from './AerospaceIntroductioncards';
import DigitalmobilityTabscards from './DigitalmobilityTabscards';
import Ditalcards from './Ditalcards';
import Digitalcapabilityhovercards from './Digitalcapabilityhovercards';
import Engineeringpagetab from './Engineeringpagetab';
import Engineeringsectionspage from './Engineeringsectionspage';
const EngineeringPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
          // Scroll to the top of the page when the component mounts
 
  return (
    <div style={{background:'#fff'}}>
        <EngineeringBanner />
        <Engineeringsectionspage />
        <Automotivemobilitecards />
        {/* <Engineeringpagetab /> */}
        <Ditalcards />
        <Digitalcapabilityhovercards />
       
           <DigitalmobilityTabscards />


        <style>
          {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
        </style>
    </div>
  )
}

export default EngineeringPage;